(function () {
function $c3b10a83b523f372$export$71511d61b312f219(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}


function $c50969dc1df61e8b$export$71511d61b312f219(arr) {
    if (Array.isArray(arr)) return (0, $c3b10a83b523f372$export$71511d61b312f219)(arr);
}


function $09c9f293d010c0e1$export$71511d61b312f219(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}


function $38c2d4931cb7a7c4$export$71511d61b312f219() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}



function $d4f69c5c6c4654b1$export$71511d61b312f219(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return (0, $c3b10a83b523f372$export$71511d61b312f219)(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return (0, $c3b10a83b523f372$export$71511d61b312f219)(o, minLen);
}


function $227c6742e0ff6f82$export$71511d61b312f219(arr) {
    return (0, $c50969dc1df61e8b$export$71511d61b312f219)(arr) || (0, $09c9f293d010c0e1$export$71511d61b312f219)(arr) || (0, $d4f69c5c6c4654b1$export$71511d61b312f219)(arr) || (0, $38c2d4931cb7a7c4$export$71511d61b312f219)();
}


"use strict";
// Uncomment the next lines to use your game instance in the browser
var $197cd56b15c33885$var$initialState = [
    [
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        0
    ]
];
var $3d28d7f1aac198f5$exports = {};
function $8713978b2328d32b$export$71511d61b312f219(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}


function $4fc75ccb937ab1df$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $4fc75ccb937ab1df$export$71511d61b312f219(Constructor, protoProps, staticProps) {
    if (protoProps) $4fc75ccb937ab1df$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $4fc75ccb937ab1df$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}


"use strict";
/**
 * This class represents the game.
 * Now it has a basic structure, that is needed for testing.
 * Feel free to add more props and methods if needed.
 */ var $3d28d7f1aac198f5$var$Game = /*#__PURE__*/ function() {
    function Game(initialState) {
        (0, $8713978b2328d32b$export$71511d61b312f219)(this, Game);
        this.initialState = initialState;
        // eslint-disable-next-line no-console
        console.log(initialState);
    }
    (0, $4fc75ccb937ab1df$export$71511d61b312f219)(Game, [
        {
            key: "moveLeft",
            value: function moveLeft() {}
        },
        {
            key: "moveRight",
            value: function moveRight() {}
        },
        {
            key: "moveUp",
            value: function moveUp() {}
        },
        {
            key: "moveDown",
            value: function moveDown() {}
        },
        {
            /**
   * @returns {number}
   */ key: "getScore",
            value: function getScore() {}
        },
        {
            /**
   * @returns {number[][]}
   */ key: "getState",
            value: function getState() {}
        },
        {
            /**
   * Returns the current game status.
   *
   * @returns {string} One of: 'idle', 'playing', 'win', 'lose'
   *
   * `idle` - the game has not started yet (the initial state);
   * `playing` - the game is in progress;
   * `win` - the game is won;
   * `lose` - the game is lost
   */ key: "getStatus",
            value: function getStatus() {}
        },
        {
            /**
   * Starts the game.
   */ key: "start",
            value: function start() {}
        },
        {
            /**
   * Resets the game.
   */ key: "restart",
            value: function restart() {}
        }
    ]);
    return Game;
}();
$3d28d7f1aac198f5$exports = $3d28d7f1aac198f5$var$Game;


var $197cd56b15c33885$var$game = new $3d28d7f1aac198f5$exports($197cd56b15c33885$var$initialState);
var $197cd56b15c33885$var$filledCells = 0;
var $197cd56b15c33885$var$score = document.querySelector(".game-score");
var $197cd56b15c33885$var$state = structuredClone($197cd56b15c33885$var$initialState);
var $197cd56b15c33885$var$cells = document.querySelectorAll(".field-cell");
var $197cd56b15c33885$var$button = document.querySelector(".button");
var $197cd56b15c33885$var$messageStart = document.querySelector(".message-start");
var $197cd56b15c33885$var$messageWin = document.querySelector(".message-win");
var $197cd56b15c33885$var$messageLose = document.querySelector(".message-lose");
$197cd56b15c33885$var$button.addEventListener("click", function() {
    if ($197cd56b15c33885$var$button.className === "button restart") $197cd56b15c33885$var$game.restart();
    if ($197cd56b15c33885$var$button.className === "button start") $197cd56b15c33885$var$game.start();
});
document.addEventListener("keydown", function(e) {
    switch(e.keyCode){
        case 37:
            $197cd56b15c33885$var$game.moveLeft();
            break;
        case 38:
            $197cd56b15c33885$var$game.moveUp();
            break;
        case 39:
            $197cd56b15c33885$var$game.moveRight();
            break;
        case 40:
            $197cd56b15c33885$var$game.moveDown();
    }
    if ((0, $227c6742e0ff6f82$export$71511d61b312f219)($197cd56b15c33885$var$cells).some(function(cell) {
        return cell.textContent === "2048";
    })) $197cd56b15c33885$var$messageWin.className = "message message-win";
    if ($197cd56b15c33885$var$filledCells === $197cd56b15c33885$var$cells.length && !$197cd56b15c33885$var$canGameContinue()) $197cd56b15c33885$var$messageLose.className = "message message-lose";
});
$197cd56b15c33885$var$game.start = function() {
    $197cd56b15c33885$var$messageStart.className = "message message-start hidden";
    $197cd56b15c33885$var$messageLose.className = "message message-lose hidden";
    $197cd56b15c33885$var$messageWin.className = "message message-win hidden";
    $197cd56b15c33885$var$button.className = "button restart";
    $197cd56b15c33885$var$button.textContent = "Restart";
    $197cd56b15c33885$var$addRandomNumInCells();
    $197cd56b15c33885$var$addRandomNumInCells();
};
$197cd56b15c33885$var$game.restart = function() {
    $197cd56b15c33885$var$filledCells = 0;
    $197cd56b15c33885$var$score.textContent = 0;
    $197cd56b15c33885$var$state = structuredClone($197cd56b15c33885$var$initialState);
    $197cd56b15c33885$var$game.start();
};
$197cd56b15c33885$var$game.getScore = function() {
    var totalScore = 0;
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = $197cd56b15c33885$var$state[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var raw = _step.value;
            totalScore += raw.reduce(function(sum, num) {
                return sum + num;
            });
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return totalScore;
};
function $197cd56b15c33885$var$addRandomNumInCells() {
    var randomRowIndex = Math.round(Math.random() * 3);
    var randomColumnIndex = Math.round(Math.random() * 3);
    var cellTextContent = Math.random() < 0.1 ? 4 : 2;
    while($197cd56b15c33885$var$state[randomRowIndex][randomColumnIndex] > 0 && $197cd56b15c33885$var$filledCells < $197cd56b15c33885$var$cells.length){
        randomRowIndex = Math.round(Math.random() * 3);
        randomColumnIndex = Math.round(Math.random() * 3);
    }
    $197cd56b15c33885$var$state[randomRowIndex][randomColumnIndex] = cellTextContent;
    $197cd56b15c33885$var$filledCells++;
    $197cd56b15c33885$var$score.textContent = $197cd56b15c33885$var$game.getScore();
    $197cd56b15c33885$var$changeRealState();
}
function $197cd56b15c33885$var$changeRealState() {
    for(var i = 0; i < $197cd56b15c33885$var$cells.length; i++){
        $197cd56b15c33885$var$cells[i].textContent = $197cd56b15c33885$var$state[Math.floor(i / 4)][i % 4] === 0 ? "" : $197cd56b15c33885$var$state[Math.floor(i / 4)][i % 4];
        $197cd56b15c33885$var$cells[i].className = $197cd56b15c33885$var$state[Math.floor(i / 4)][i % 4] === 0 ? "field-cell" : "field-cell field-cell--".concat($197cd56b15c33885$var$state[Math.floor(i / 4)][i % 4]);
    }
}
function $197cd56b15c33885$var$canGameContinue() {
    var isSomethingChanged = false;
    for(var i = $197cd56b15c33885$var$state.length - 2; i >= 0; i--){
        for(var j = 0; j < $197cd56b15c33885$var$state[i].length; j++)if ($197cd56b15c33885$var$state[i + 1][j] === $197cd56b15c33885$var$state[i][j] && $197cd56b15c33885$var$state[i][j] !== 0) isSomethingChanged = true;
    }
    for(var i1 = $197cd56b15c33885$var$state.length - 1; i1 > 0; i1--){
        for(var j1 = 0; j1 < $197cd56b15c33885$var$state[i1].length; j1++)if ($197cd56b15c33885$var$state[i1 - 1][j1] === $197cd56b15c33885$var$state[i1][j1] && $197cd56b15c33885$var$state[i1][j1] !== 0) isSomethingChanged = true;
    }
    for(var i2 = 0; i2 < $197cd56b15c33885$var$state.length; i2++){
        for(var j2 = 1; j2 < $197cd56b15c33885$var$state[i2].length; j2++)if ($197cd56b15c33885$var$state[i2][j2 - 1] === $197cd56b15c33885$var$state[i2][j2] && $197cd56b15c33885$var$state[i2][j2] !== 0) isSomethingChanged = true;
    }
    for(var i3 = 0; i3 < $197cd56b15c33885$var$state.length; i3++){
        for(var j3 = $197cd56b15c33885$var$state[i3].length - 2; j3 >= 0; j3--)if ($197cd56b15c33885$var$state[i3][j3 + 1] === $197cd56b15c33885$var$state[i3][j3] && $197cd56b15c33885$var$state[i3][j3] !== 0) isSomethingChanged = true;
    }
    return isSomethingChanged;
}
$197cd56b15c33885$var$game.moveDown = function() {
    var isSomethingChanged = false;
    var jWasUsed = [];
    for(var n = 0; n < $197cd56b15c33885$var$state.length; n++){
        var _loop = function(i) {
            var _loop = function(j) {
                if ($197cd56b15c33885$var$state[i + 1][j] === $197cd56b15c33885$var$state[i][j] && $197cd56b15c33885$var$state[i][j] !== 0 && jWasUsed.every(function(ind) {
                    return ind !== j;
                })) {
                    if ($197cd56b15c33885$var$state[0][j] !== 0 && $197cd56b15c33885$var$state[3][j] !== 0 && $197cd56b15c33885$var$state[0][j] === $197cd56b15c33885$var$state[1][j] && $197cd56b15c33885$var$state[2][j] === $197cd56b15c33885$var$state[3][j]) {
                        $197cd56b15c33885$var$state[3][j] = $197cd56b15c33885$var$state[2][j] * 2;
                        $197cd56b15c33885$var$state[2][j] = $197cd56b15c33885$var$state[1][j] * 2;
                        $197cd56b15c33885$var$state[1][j] = 0;
                        $197cd56b15c33885$var$state[0][j] = 0;
                        isSomethingChanged = true;
                        jWasUsed.push(j);
                        $197cd56b15c33885$var$filledCells -= 2;
                        return "continue";
                    }
                    $197cd56b15c33885$var$state[i + 1][j] *= 2;
                    $197cd56b15c33885$var$state[i][j] = 0;
                    isSomethingChanged = true;
                    jWasUsed.push(j);
                    $197cd56b15c33885$var$filledCells--;
                }
                if ($197cd56b15c33885$var$state[i + 1][j] === 0 && $197cd56b15c33885$var$state[i][j] !== 0) {
                    var ref;
                    ref = [
                        $197cd56b15c33885$var$state[i][j],
                        $197cd56b15c33885$var$state[i + 1][j]
                    ], $197cd56b15c33885$var$state[i + 1][j] = ref[0], $197cd56b15c33885$var$state[i][j] = ref[1], ref;
                    isSomethingChanged = true;
                }
            };
            for(var j = 0; j < $197cd56b15c33885$var$state[i].length; j++)_loop(j);
        };
        for(var i = $197cd56b15c33885$var$state.length - 2; i >= 0; i--)_loop(i);
    }
    if (isSomethingChanged) $197cd56b15c33885$var$addRandomNumInCells();
};
$197cd56b15c33885$var$game.moveUp = function() {
    var isSomethingChanged = false;
    var jWasUsed = [];
    for(var n = 0; n < $197cd56b15c33885$var$state.length; n++){
        var _loop = function(i) {
            var _loop = function(j) {
                if ($197cd56b15c33885$var$state[i - 1][j] === $197cd56b15c33885$var$state[i][j] && $197cd56b15c33885$var$state[i][j] !== 0 && jWasUsed.every(function(ind) {
                    return ind !== j;
                })) {
                    if ($197cd56b15c33885$var$state[0][j] !== 0 && $197cd56b15c33885$var$state[3][j] !== 0 && $197cd56b15c33885$var$state[0][j] === $197cd56b15c33885$var$state[1][j] && $197cd56b15c33885$var$state[2][j] === $197cd56b15c33885$var$state[3][j]) {
                        $197cd56b15c33885$var$state[0][j] = $197cd56b15c33885$var$state[1][j] * 2;
                        $197cd56b15c33885$var$state[1][j] = $197cd56b15c33885$var$state[2][j] * 2;
                        $197cd56b15c33885$var$state[2][j] = 0;
                        $197cd56b15c33885$var$state[3][j] = 0;
                        isSomethingChanged = true;
                        jWasUsed.push(j);
                        $197cd56b15c33885$var$filledCells -= 2;
                        return "continue";
                    }
                    $197cd56b15c33885$var$state[i - 1][j] *= 2;
                    $197cd56b15c33885$var$state[i][j] = 0;
                    isSomethingChanged = true;
                    jWasUsed.push(j);
                    $197cd56b15c33885$var$filledCells--;
                }
                if ($197cd56b15c33885$var$state[i - 1][j] === 0 && $197cd56b15c33885$var$state[i][j] !== 0) {
                    var ref;
                    ref = [
                        $197cd56b15c33885$var$state[i][j],
                        $197cd56b15c33885$var$state[i - 1][j]
                    ], $197cd56b15c33885$var$state[i - 1][j] = ref[0], $197cd56b15c33885$var$state[i][j] = ref[1], ref;
                    isSomethingChanged = true;
                }
            };
            for(var j = 0; j < $197cd56b15c33885$var$state[i].length; j++)_loop(j);
        };
        for(var i = $197cd56b15c33885$var$state.length - 1; i > 0; i--)_loop(i);
    }
    if (isSomethingChanged) $197cd56b15c33885$var$addRandomNumInCells();
};
$197cd56b15c33885$var$game.moveLeft = function() {
    var isSomethingChanged = false;
    var iWasUsed = [];
    for(var n = 0; n < $197cd56b15c33885$var$state.length; n++){
        for(var i = 0; i < $197cd56b15c33885$var$state.length; i++)for(var j = 1; j < $197cd56b15c33885$var$state[i].length; j++){
            if ($197cd56b15c33885$var$state[i][j - 1] === $197cd56b15c33885$var$state[i][j] && $197cd56b15c33885$var$state[i][j] !== 0 && iWasUsed.every(function(ind) {
                return ind !== i;
            })) {
                if ($197cd56b15c33885$var$state[i][0] !== 0 && $197cd56b15c33885$var$state[i][3] !== 0 && $197cd56b15c33885$var$state[i][0] === $197cd56b15c33885$var$state[i][1] && $197cd56b15c33885$var$state[i][2] === $197cd56b15c33885$var$state[i][3]) {
                    $197cd56b15c33885$var$state[i][0] = $197cd56b15c33885$var$state[i][1] * 2;
                    $197cd56b15c33885$var$state[i][1] = $197cd56b15c33885$var$state[i][2] * 2;
                    $197cd56b15c33885$var$state[i][2] = 0;
                    $197cd56b15c33885$var$state[i][3] = 0;
                    isSomethingChanged = true;
                    iWasUsed.push(i);
                    $197cd56b15c33885$var$filledCells -= 2;
                    continue;
                }
                $197cd56b15c33885$var$state[i][j - 1] *= 2;
                $197cd56b15c33885$var$state[i][j] = 0;
                isSomethingChanged = true;
                iWasUsed.push(i);
                $197cd56b15c33885$var$filledCells--;
            }
            if ($197cd56b15c33885$var$state[i][j - 1] === 0 && $197cd56b15c33885$var$state[i][j] !== 0) {
                var ref;
                ref = [
                    $197cd56b15c33885$var$state[i][j],
                    $197cd56b15c33885$var$state[i][j - 1]
                ], $197cd56b15c33885$var$state[i][j - 1] = ref[0], $197cd56b15c33885$var$state[i][j] = ref[1], ref;
                isSomethingChanged = true;
            }
        }
    }
    if (isSomethingChanged) $197cd56b15c33885$var$addRandomNumInCells();
};
$197cd56b15c33885$var$game.moveRight = function() {
    var isSomethingChanged = false;
    var iWasUsed = [];
    for(var n = 0; n < $197cd56b15c33885$var$state.length; n++){
        for(var i = 0; i < $197cd56b15c33885$var$state.length; i++)for(var j = $197cd56b15c33885$var$state[i].length - 2; j >= 0; j--){
            if ($197cd56b15c33885$var$state[i][j + 1] === $197cd56b15c33885$var$state[i][j] && $197cd56b15c33885$var$state[i][j] !== 0 && iWasUsed.every(function(ind) {
                return ind !== i;
            })) {
                if ($197cd56b15c33885$var$state[i][0] !== 0 && $197cd56b15c33885$var$state[i][3] !== 0 && $197cd56b15c33885$var$state[i][0] === $197cd56b15c33885$var$state[i][1] && $197cd56b15c33885$var$state[i][2] === $197cd56b15c33885$var$state[i][3]) {
                    $197cd56b15c33885$var$state[i][3] = $197cd56b15c33885$var$state[i][2] * 2;
                    $197cd56b15c33885$var$state[i][2] = $197cd56b15c33885$var$state[i][1] * 2;
                    $197cd56b15c33885$var$state[i][1] = 0;
                    $197cd56b15c33885$var$state[i][0] = 0;
                    isSomethingChanged = true;
                    iWasUsed.push(i);
                    $197cd56b15c33885$var$filledCells -= 2;
                    continue;
                }
                $197cd56b15c33885$var$state[i][j + 1] *= 2;
                $197cd56b15c33885$var$state[i][j] = 0;
                isSomethingChanged = true;
                iWasUsed.push(i);
                $197cd56b15c33885$var$filledCells--;
            }
            if ($197cd56b15c33885$var$state[i][j + 1] === 0 && $197cd56b15c33885$var$state[i][j] !== 0) {
                var ref;
                ref = [
                    $197cd56b15c33885$var$state[i][j],
                    $197cd56b15c33885$var$state[i][j + 1]
                ], $197cd56b15c33885$var$state[i][j + 1] = ref[0], $197cd56b15c33885$var$state[i][j] = ref[1], ref;
                isSomethingChanged = true;
            }
        }
    }
    if (isSomethingChanged) $197cd56b15c33885$var$addRandomNumInCells();
};

})();
//# sourceMappingURL=index.eff1ec7a.js.map
